import * as React from 'react';
import CSSMotion from 'rc-motion';
import { render, unmount } from "rc-util/es/React/render";
import classNames from 'classnames';
import { getTargetWaveColor, getValidateContainer } from './util';

var WaveEffect = function WaveEffect(props) {
  var className = props.className,
      left = props.left,
      top = props.top,
      width = props.width,
      height = props.height,
      color = props.color,
      borderRadius = props.borderRadius,
      scale = props.scale;
  var divRef = React.useRef(null);
  var waveStyle = {
    left: left,
    top: top,
    width: width,
    height: height,
    borderRadius: borderRadius.map(function (radius) {
      return "".concat(radius, "px");
    }).join(' '),
    '--wave-scale': scale
  };

  if (color) {
    waveStyle['--wave-color'] = color;
  }

  return (
    /*#__PURE__*/
    React.createElement(CSSMotion, {
      visible: true,
      motionAppear: true,
      motionName: "wave-motion",
      motionDeadline: 5000,
      onAppearEnd: function onAppearEnd(_, event) {
        var _a;

        if (event.deadline || event.propertyName === 'opacity') {
          var holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
          unmount(holder).then(function () {
            var _a;

            (_a = holder.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(holder);
          });
        }

        return false;
      }
    }, function (_ref) {
      var motionClassName = _ref.className;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: divRef,
          className: classNames(className, motionClassName),
          style: waveStyle
        })
      );
    })
  );
};

function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}

export default function showWaveEffect(container, node, className) {
  var nodeStyle = getComputedStyle(node);
  var nodeRect = node.getBoundingClientRect(); // Get wave color from target

  var waveColor = getTargetWaveColor(node); // Get border radius

  var borderTopLeftRadius = nodeStyle.borderTopLeftRadius,
      borderTopRightRadius = nodeStyle.borderTopRightRadius,
      borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius,
      borderBottomRightRadius = nodeStyle.borderBottomRightRadius; // Do scale calc

  var offsetWidth = node.offsetWidth;
  var scale = validateNum(nodeRect.width / offsetWidth); // Create holder

  var holder = document.createElement('div');
  getValidateContainer(container).appendChild(holder);
  render(
  /*#__PURE__*/
  React.createElement(WaveEffect, {
    left: nodeRect.left,
    top: nodeRect.top,
    width: nodeRect.width,
    height: nodeRect.height,
    color: waveColor,
    className: className,
    scale: scale,
    borderRadius: [borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(function (radius) {
      return validateNum(parseFloat(radius) * scale);
    })
  }), holder);
}